// ============================================================
// MBC84 — Contenu du site. Tout est centralisé ici pour être
// modifié facilement sans toucher aux composants.
// ⚠️ Les éléments marqués "placeholder" sont à remplacer par les
// vraies données du club (chiffres, coordonnées, photos, liens...).
// ============================================================

export const CLUB = {
  name: "Motards Business Club 84",
  short: "MBC84",
  baseline: "La passion de la moto. La force du réseau.",
  tagline: "Faire du réseau, partager la passion, développer son business.",
  regions: "Vaucluse • Gard • Sud-Est",
  heroText:
    "Un club qui réunit entrepreneurs, professionnels et passionnés de moto du Vaucluse et d'Avignon autour d'une même ambition : créer des rencontres, développer son réseau et vivre des expériences uniques.",
  contact: {
    email: "motardsbusinessclub84@gmail.com",
    phone: "06 66 63 84 57",
    zone: "Vaucluse — Avignon et alentours",
    address: "2 impasse des Aubépines, 84370 Bédarrides",
  },
  socials: [
    { name: "Instagram", url: "https://www.instagram.com/motards_business_club84" },
    { name: "Facebook", url: "https://www.facebook.com/share/1BzECmVEDP/" },
    { name: "TikTok", url: "https://www.tiktok.com/@motardsbusinessclub84" },
    { name: "LinkedIn", url: "https://www.linkedin.com/in/motards-business-club-4bb42543b" },
  ],
};

// ⚠️ PLACEHOLDERS — liens App Store / Google Play et adhésion à remplacer
export const APP_LINKS = {
  appStore: "/bientot",
  googlePlay: "https://play.google.com/store/apps/details?id=com.motardsbusinessclub.aab",
  joinClub: "/bientot",
};

export const APP_VIDEO = "/video/presentation.mp4";

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "Le Club", to: "/le-club" },
  { label: "Fondateurs", to: "/nos-fondateurs" },
  { label: "Application", to: "/application" },
  { label: "Adhésions", to: "/adhesion" },
  { label: "Événements", to: "/evenements" },
  { label: "Contact", to: "/contact" },
  { label: "Confidentialité", to: "/confidentialite" },
];

// Images optimisées : largeur maîtrisée + WebP/AVIF automatiques (auto=format).
// Images locales optimisées (WebP multi-tailles générées dans /public/images)
export const IMAGES = {
  heroRider: "/images/heroRider",
  sunsetCruise: "/images/sunsetCruise",
  riderPortrait: "/images/riderPortrait",
  lounge: "/images/lounge",
  venue: "/images/venue",
  afterwork1: "/images/afterwork1",
  afterwork2: "/images/afterwork2",
  meeting: "/images/meeting",
  groupRide: "/images/groupRide",
};

export const imgSrc = (key, w = 1200) => `${IMAGES[key]}-${w}.webp`;

export const imgSrcset = (key, widths = [480, 800, 1200, 1600]) =>
  widths.map((w) => `${IMAGES[key]}-${w}.webp ${w}w`).join(", ");

export const GALLERY = [
  { key: "heroRider", alt: "Sortie de groupe au coucher du soleil", cat: "Balades", tall: true },
  { key: "lounge", alt: "Rencontres professionnelles", cat: "Rencontres", tall: false },
  { key: "sunsetCruise", alt: "Balade moto de fin de journée", cat: "Balades", tall: false },
  { key: "afterwork1", alt: "Afterwork du club", cat: "Afterworks", tall: true },
  { key: "riderPortrait", alt: "Membre du club et sa moto", cat: "Motos", tall: false },
  { key: "venue", alt: "Événement partenaire", cat: "Événements", tall: false },
  { key: "afterwork2", alt: "Moment d'échange entre membres", cat: "Afterworks", tall: false },
  { key: "groupRide", alt: "Groupe de motards sur la route", cat: "Balades", tall: false },
  { key: "meeting", alt: "Meeting business", cat: "Rencontres", tall: false },
];

export const CONCEPT = [
  {
    title: "Business",
    icon: "briefcase",
    text: "Développez votre réseau professionnel grâce à une communauté d'entrepreneurs et de professionnels partageant les mêmes valeurs.",
  },
  {
    title: "Moto",
    icon: "route",
    text: "Partagez votre passion avec d'autres motards, découvrez de nouvelles routes et participez à des sorties.",
  },
  {
    title: "Rencontres",
    icon: "users",
    text: "Afterworks, événements, rencontres professionnelles, sorties et expériences exclusives.",
  },
  {
    title: "Communauté",
    icon: "smartphone",
    text: "Une communauté active réunie autour d'une application pensée pour connecter les membres.",
  },
];

export const FEATURES = [
  { title: "Fil d'actualité", desc: "Les news du club, les publications des membres et des partenaires en continu.", icon: "newspaper", featured: true },
  { title: "Annuaire des membres", desc: "Tous les profils professionnels de la communauté, à portée de main.", icon: "users" },
  { title: "Membres autour de moi", desc: "Localisez les membres à proximité et multipliez les rencontres.", icon: "radar" },
  { title: "Profil moto", desc: "Votre monture, vos routes préférées, votre univers.", icon: "gauge" },
  { title: "Agenda des événements", desc: "Sorties, afterworks et rendez-vous business, toujours à jour.", icon: "calendar" },
  { title: "Messagerie privée", desc: "Échangez en direct avec les membres du club.", icon: "message" },
  { title: "Offres exclusives MBC84", desc: "Avantages et remises réservés aux membres.", icon: "tag" },
  { title: "Parrainage", desc: "Invitez un motard, gagnez un crédit sur votre cotisation.", icon: "gift" },
  { title: "Notifications", desc: "Ne manquez aucun événement ni aucune annonce.", icon: "bell" },
  { title: "Recherche et filtres", desc: "Par métier, ville, passion ou marque de moto.", icon: "search" },
  { title: "Réseau professionnel", desc: "Des contacts qualifiés, partout dans le Sud-Est.", icon: "network" },
  { title: "Géolocalisation", desc: "Les bonnes adresses et les membres, carte en main.", icon: "map" },
];

export const SAMPLE_MEMBERS = [
  { name: "Prénom Nom", job: "Chef d'entreprise", city: "Avignon", img: "/images/avatar-1.webp" },
  { name: "Prénom Nom", job: "Profession libérale", city: "Orange", img: "/images/avatar-2.webp" },
  { name: "Prénom Nom", job: "Dirigeant de PME", city: "Nîmes", img: "/images/avatar-3.webp" },
  { name: "Prénom Nom", job: "Commerçant indépendant", city: "Cavaillon", img: "/images/avatar-4.webp" },
];

export const EVENT_TYPES = [
  { label: "Sorties moto", icon: "road" },
  { label: "Business meetings", icon: "handshake" },
  { label: "Afterworks", icon: "beer" },
  { label: "Événements partenaires", icon: "mic" },
  { label: "Expériences et activités", icon: "flag" },
  { label: "Rencontres professionnelles", icon: "briefcase" },
];

// ⚠️ Cartes d'événements FICTIVES, uniquement pour le design.
export const SAMPLE_EVENTS = [
  { title: "Run Business — Balade entre membres", type: "Sorties moto", icon: "road", date: "Date à venir", place: "Lieu à définir — Vaucluse", img: "groupRide" },
  { title: "Pitch & Ride", type: "Business meetings", icon: "handshake", date: "Date à venir", place: "Lieu à définir — Avignon", img: "meeting" },
  { title: "Afterwork MBC84", type: "Afterworks", icon: "beer", date: "Date à venir", place: "Lieu à définir — Avignon", img: "afterwork1" },
  { title: "Soirée Partenaires", type: "Événements partenaires", icon: "mic", date: "Date à venir", place: "Lieu à définir — Gard", img: "venue" },
  { title: "Grand Tour Sud-Est", type: "Expériences et activités", icon: "flag", date: "Date à venir", place: "Départ — Vaucluse", img: "sunsetCruise" },
  { title: "Petit-déj Networking", type: "Rencontres professionnelles", icon: "briefcase", date: "Date à venir", place: "Lieu à définir — Vaucluse", img: "lounge" },
];

export const PLANS = [
  {
    id: "pro",
    name: "Membre Pro",
    price: "500 €",
    period: "HT / an",
    note: "soit 600 € TTC — ou formule mensuelle",
    highlight: true,
    badge: "Le plus complet",
    theme: "gold",
    desc: "Pour les entrepreneurs et professionnels qui veulent tirer pleinement parti du réseau.",
    features: [
      "Profil professionnel complet",
      "Présence dans l'annuaire",
      "Réseau professionnel",
      "Accès aux événements",
      "Messagerie",
      "Offres MBC84",
      "Fonctionnalités communautaires",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: "199 €",
    period: "/ an",
    note: "ou formule mensuelle",
    highlight: false,
    badge: null,
    theme: "gold-soft",
    desc: "Pour les passionnés de moto qui veulent vivre le club et la communauté.",
    features: [
      "Profil passion",
      "Moto et centres d'intérêt",
      "Événements",
      "Communauté",
      "Messagerie",
      "Fonctionnalités de l'application",
    ],
  },
  {
    id: "partenaire",
    name: "Partenaire",
    price: "1 000 €",
    period: "HT / an",
    note: "soit 1 200 € TTC — entreprises, marques et annonceurs",
    highlight: false,
    badge: "Entreprises & marques",
    theme: "green",
    desc: "Associez votre marque à une communauté active et qualifiée.",
    features: [
      "Visibilité auprès de la communauté",
      "Présence partenaire",
      "Publication d'offres",
      "Publications dans le fil d'actualité",
      "Visibilité lors des événements",
      "Communication auprès des membres",
    ],
  },
];

export const COMPARISON_ROWS = [
  { label: "Profil membre", pro: "Pro complet", premium: "Passion", partenaire: "Fiche entreprise" },
  { label: "Présence dans l'annuaire", pro: true, premium: true, partenaire: "Mise en avant" },
  { label: "Accès aux événements", pro: true, premium: true, partenaire: "Visibilité sur site" },
  { label: "Messagerie privée", pro: true, premium: true, partenaire: "Via l'équipe MBC84" },
  { label: "Offres exclusives MBC84", pro: true, premium: true, partenaire: "Publication d'offres" },
  { label: "Publications fil d'actualité", pro: false, premium: false, partenaire: true },
  { label: "Visibilité lors des événements", pro: false, premium: false, partenaire: true },
  { label: "Communication auprès des membres", pro: false, premium: false, partenaire: true },
  { label: "Programme de parrainage", pro: true, premium: true, partenaire: false },
  { label: "Fonctionnalités communautaires", pro: true, premium: true, partenaire: false },
];

export const PARRAINAGE_STEPS = [
  { step: "Partage", desc: "Vous transmettez votre code personnel à un futur motard membre." },
  { step: "Inscription", desc: "Votre filleul s'inscrit et bénéficie de -10 % sur son adhésion." },
  { step: "Avantage", desc: "Il rejoint le club avec un avantage immédiat." },
  { step: "Crédit", desc: "Vous gagnez un crédit cumulable, déduit de votre prochaine cotisation." },
];

// Chiffres réels du club — affichés en compteurs animés.
export const STATS = [
  { value: 600, suffix: "+", label: "membres" },
  { value: 200, suffix: "+", label: "entreprises" },
  { value: 50, suffix: "+", label: "événements" },
  { value: 50, suffix: "+", label: "partenaires" },
];

// ⚠️ TÉMOIGNAGES D'EXEMPLE — à remplacer par de vrais témoignages.
export const TESTIMONIALS = [
  {
    quote: "Une communauté qui permet réellement de mélanger passion moto et réseau professionnel.",
    name: "Prénom Nom",
    job: "Chef d'entreprise",
    img: "/images/avatar-1.webp",
  },
  {
    quote: "Des rencontres authentiques, sur la route comme autour d'une table. Mon réseau a changé de dimension.",
    name: "Prénom Nom",
    job: "Profession libérale",
    img: "/images/avatar-2.webp",
  },
  {
    quote: "Enfin un club structuré où la moto ouvre de vraies opportunités professionnelles.",
    name: "Prénom Nom",
    job: "Dirigeant de PME",
    img: "/images/avatar-3.webp",
  },
];

export const CONTACT_SUBJECTS = [
  "Devenir membre",
  "Devenir partenaire",
  "Question sur l'application",
  "Événement",
  "Presse",
  "Autre",
];

export const MARQUEE_ITEMS = [
  "Ride. Connect. Grow.",
  "La passion de la moto. La force du réseau.",
  "Plus qu'un club moto. Un réseau.",
  "Faire du réseau — Partager la passion — Développer son business",
  "Vaucluse • Gard • Sud-Est",
];

// FAQ — réponses basées uniquement sur les informations réelles du club.
export const FAQ_DATA = [
  { q: "Qu'est-ce que le Motards Business Club 84 ?", a: "Un club qui réunit entrepreneurs, professionnels et passionnés de moto autour d'une même ambition : créer des rencontres, développer son réseau et vivre des expériences uniques, dans le Vaucluse, le Gard et le Sud-Est." },
  { q: "Comment rejoindre le club ?", a: "Choisissez la formule qui vous correspond sur la page Adhésions — Membre Pro (500 € HT/an), Premium (199 €/an) ou Partenaire (1 000 € HT/an) — puis cliquez sur « Devenir membre ». Vous pouvez aussi nous écrire via le formulaire de contact." },
  { q: "Quelle est la différence entre Membre Pro et Premium ?", a: "Membre Pro est orienté réseau professionnel : profil professionnel complet, présence dans l'annuaire et offres MBC84. Premium est orienté passion et communauté : profil passion, moto et centres d'intérêt, événements et messagerie." },
  { q: "Comment fonctionne le parrainage ?", a: "Chaque membre dispose d'un code personnel. Votre filleul bénéficie de -10 % sur son adhésion et vous gagnez un crédit cumulable, déduit de votre prochaine cotisation." },
  { q: "L'application est-elle incluse dans l'adhésion ?", a: "Oui : l'application MBC84 (fil d'actualité, annuaire, événements, messagerie, offres) est la colonne vertébrale du club et accompagne chaque formule selon ses avantages." },
  { q: "Peut-on rejoindre le club sans être entrepreneur ?", a: "Oui : la formule Premium s'adresse aux passionnés de moto qui veulent vivre le club et la communauté, sans obligation d'être entrepreneur." },
  { q: "Où se déroulent les événements ?", a: "Dans le Vaucluse (autour d'Avignon et de Bédarrides), dans le Gard et plus largement dans le Sud-Est : sorties moto, afterworks, business meetings et événements partenaires." },
  { q: "Comment devenir partenaire du club ?", a: "Rendez-vous sur la page Partenaires ou écrivez-nous via le formulaire de contact en sélectionnant « Devenir partenaire » : nous vous présentons les modalités de visibilité et de collaboration." },
];

export const BLOG_CATEGORIES = [
  "Le club, ses rencontres et ses partenaires",
  "Entrepreneuriat & réseau professionnel",
  "Moto & art de vivre",
  "Moto et communauté",
  "Événements et afterworks",
  "Entreprises et partenaires du club",
  "Vie du Motards Business Club 84",
  "Conseils pour développer son réseau",
];
